'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { LicenseSuggestion } from '@/types/licenses';
import { useImageBaseUrl } from '@/atoms/processEnvAtom';
import { SuggestionLinkItem } from '@/components/Header/SuggestionLinkItem';
import { getUserImageSrc } from '@/utility/images';
import { getShowroomHrefArgs } from '@/utility/urls';
type LicenseSuggestionItemProps = {
  license: LicenseSuggestion;
  /** Navigates to the showroom — also resets the search field. */
  onNavigate: () => void;
  /** Renders the group heading above the first license of the list. */
  showGroupLabel?: boolean;
  /** Separates the last license from the group below. */
  showDivider?: boolean;
};
export const LicenseSuggestionItem = t0 => {
  const $ = _c(29);
  const {
    license,
    onNavigate,
    showGroupLabel,
    showDivider
  } = t0;
  const t = useTranslations("header");
  const imageBaseUrl = useImageBaseUrl();
  let t1;
  if ($[0] !== license.slug) {
    t1 = getShowroomHrefArgs({
      userSlug: license.slug
    });
    $[0] = license.slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== showGroupLabel || $[3] !== t) {
    t2 = showGroupLabel ? t("licenseSuggestionsLabel") : undefined;
    $[2] = showGroupLabel;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `Searchbar - Licensing - ${license.name}`;
  let t4;
  if ($[5] !== imageBaseUrl || $[6] !== license.userId) {
    t4 = getUserImageSrc(imageBaseUrl, license.userId, 80);
    $[5] = imageBaseUrl;
    $[6] = license.userId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <img className="size-10 shrink-0 bg-white" src={t4} draggable={false} loading="eager" alt="" />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("licenseSuggestionsLabel");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="sr-only">{t6}: </span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== license.name || $[15] !== t7) {
    t8 = <span className="min-w-24 truncate">{t7}{license.name}</span>;
    $[14] = license.name;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== license.matchedTerm || $[18] !== t) {
    t9 = license.matchedTerm && <span className="ml-auto min-w-0 truncate pl-2 text-sm text-neutral-700">{t("suggestionVia", {
        term: license.matchedTerm
      })}</span>;
    $[17] = license.matchedTerm;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onNavigate || $[21] !== showDivider || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t5 || $[26] !== t8 || $[27] !== t9) {
    t10 = <SuggestionLinkItem href={t1} groupLabel={t2} showDivider={showDivider} onNavigate={onNavigate} dataTracking={t3}>{t5}{t8}{t9}</SuggestionLinkItem>;
    $[20] = onNavigate;
    $[21] = showDivider;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};